import SvgIcon from "../layout/svg-icons/svg-icons";

interface IProps {
  submitAnother: () => void;
  formType: string;
}

export const SuccessPage: React.FC<IProps> = ({ submitAnother, formType }) => {

  const renderCompletedIcon = (h: string, w: string) => {
    return (
      <div
        className={`rounded-full border-2 p-0.5 border-tipFormBlue flex items-center justify-center`}
        style={{ width: `${w}px`, height: `${h}px` }}
      >
        <SvgIcon width={w} height={h} viewBox="0 0 14 12" fill="none">
          <path d="M5.00878 11C4.7803 11.0009 4.56052 10.9089 4.39647 10.7437L0.264208 6.57747C0.181845 6.49392 0.116126 6.39434 0.0708037 6.2844C0.0254817 6.17446 0.00144401 6.05633 6.31568e-05 5.93674C-0.00272561 5.69522 0.086941 5.46244 0.249337 5.28961C0.411734 5.11678 0.633557 5.01806 0.866009 5.01516C1.09846 5.01226 1.3225 5.10543 1.48884 5.27416L5.01228 8.82508L12.5105 1.25881C12.6771 1.09007 12.9014 0.997006 13.134 1.00007C13.3666 1.00314 13.5885 1.1021 13.7509 1.27517C13.9133 1.44824 14.0029 1.68125 13.9999 1.92294C13.997 2.16463 13.9017 2.3952 13.7352 2.56393L5.6211 10.7437C5.45705 10.9089 5.23727 11.0009 5.00878 11Z" fill="#1A56DB" />
        </SvgIcon>
      </div>
    )
  };

  return (
    <div className={"h-screen max-[1200px]:flex max-[1200px]:flex-col max-[1200px]:items-center"}>
      <div className='text-[30px] font-bold leading-[45px]'>
        Thank you for your tip
      </div>
      <div className={'flex h-[70px] w-[70px] mt-2 md:hidden'}>{renderCompletedIcon('70', '70')}</div>
      <div className='text-[16x] text-center md:text-left mb-[10px] font-medium leading-[24px] my-4'>
        <div className='mb-3'>Your {formType} form has been submitted.</div>
        <div className='mb-3'>
          We appreciate you taking the time to fill out the {formType} form, and join our fight against hatred.
        </div>
        <div>
          If you provided an email address, you will be contacted about the status of your submission.
        </div>
        <div className={'flex flex-row justify-center align-center my-3 p-3 w-full border-t border-gray-300'}>
          <button
            className={'rounded-lg flex justify-center items-center w-[200px] h-[35px] bg-black !text-white font-medium leading-6 mt-2'}
            aria-label={'submit again'}
            onClick={submitAnother}
          >
            Submit another Tip
          </button>
        </div>
      </div>
    </div>
  );
}